import { createFileRoute } from "@tanstack/react-router";
import { ProjectDetailsView } from "@/features/projects/ProjectDetailsView/ProjectDetailsView";
import { z } from "zod";

const validateSearch = z.object({
  tab: z
    .enum(["overview", "members", "billing", "access", "history"])
    .optional(),
  entryId: z.string().min(1).cuid().optional(),
});

export const Route = createFileRoute("/projects/$projectId")({
  component: ProjectDetailsView,
  validateSearch: (search) => validateSearch.parse(search),
});
